<template>
  <div class="index">
    <el-row>
      <el-col :span="22" :offset="1">
        <div ref="be" class="crossRotate">
          <div class="help-header">常见问题列表</div>
          <div
            style="border-bottom: 1px solid #e7e7e7"
            v-for="(item, index) in helpList"
          >
            <p class="help-title" @click="handleResize(item.id, item.title)">
              {{ item.title }}
            </p>
          </div>
          <div class="page">
            <el-pagination
              v-if="total"
              small
              :current-page="tableinfo.pageNum"
              :page-size="tableinfo.pageSize"
              :page-sizes="[5, 10, 20, 30]"
              @current-change="changePage"
              layout="total,prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <div ref="after" class="crossRotate1">
          <div style="padding: 40px 0">
            <div class="click-btn">
              <i class="el-icon-back" @click="handleBe"></i>
            </div>
            <h3>{{ title }}</h3>
            <div v-loading="!helpDetail" v-html="helpDetail"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { helpCenterPage, helpDetailById } from "@/api/setUp.js";

export default {
  name: "index",
  components: {},
  data() {
    return {
      catalog: "",
      activeNames: [],
      helpList: [],
      helpDetail: "",
      title: "",
      total: 0,
      tableinfo: {
        pageNumber: 1,
        size: 10,
        catalogId: "dac73ae7-7689-47c9-96be-aa2fa31f6685",
        title: "",
      },
    };
  },
  methods: {
    // async handleChange(val) {
    //     if (val) {
    //         let res = await this.$http.get(`HelpCenter/${val}`)
    //         this.helpDetail = res.data.content
    //     }
    // },
    async getHelpList() {
      let res = await helpCenterPage({
        pageNumber: this.tableinfo.pageNumber - 1,
        size: this.tableinfo.size,
        catalogId: this.tableinfo.catalogId,
        title: this.tableinfo.title,
      });
      this.helpList = res.data;
      this.total = +res.headers["x-total-count"];
    },
    changePage(val) {
      this.tableinfo.pageNumber = val;
      this.getHelpList();
    },
    async handleResize(id, title) {
      this.$refs.be.className = "crossRotate1";
      this.$refs.after.className = "crossRotate";
      this.title = title;
      let res = await helpDetailById({ id: id });
      this.helpDetail = res.data.content;
    },
    handleBe() {
      this.helpDetail = "";
      this.$refs.be.className = "crossRotate";
      this.$refs.after.className = "crossRotate1";
    },
  },
  mounted() {
    this.getHelpList();
  },
};
</script>

<style lang="less" scoped>
.crossRotate {
  width: 100%;
  transition: all 1s;
  display: inline-block;
}

.crossRotate1 {
  width: 0;
  transition: all 1s;
  display: none;
}

.help-header {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2c2d3a;
  line-height: 28px;
  margin: 10px 0 26px 0;
}

.help-title {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);

  line-height: 48px;
  padding-left: 20px;
  cursor: pointer;
  box-shadow: 0px 0px 0px 0px rgba(224, 234, 241, 1);

  &:hover {
    background-color: rgba(250, 250, 250, 1);
  }
}

.click-btn {
}

.click-btn i {
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
}

h3 {
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(44, 45, 58, 1);
  margin: 50px 0;
}

.index {
  margin: 18px;
  margin-left: 38px;
  border-radius: 8px;
  padding-top: 32px;
  background: #fff;
  .help-header {
    font-size: 22px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
    // line-height: 30px;
  }

  .hover-i {
    float: right;
    color: rgba(131, 143, 153, 1);
    font-size: 16px;
    cursor: pointer;
    position: relative;

    &:hover {
      &:after {
        position: absolute;
        bottom: -30px;
        right: 0px;
        width: 220px;
        color: rgba(44, 45, 58, 1);
        text-align: center;
        background: rgba(243, 245, 247, 1);
        border-radius: 4px;
        content: "联系客服 18971608045";
      }
    }
  }
}

.page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}
</style>
